export var PREFIX_INVALID_MESSAGE = 'INVALID__';
export var PREFIX_FIELD_LABEL = 'FIELD_LABEL__';